import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrolltoTop from "./pages/ScrolltoTop";
import About from './pages/About';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Appointment from './pages/AppointmentPage/pages/Appointment';
import Pricing from './pages/Pricing';
import CreditandFinancialSolutions from './pages/ProtectionPlans';
import BusinessSolutions from './pages/BusinessFunding';
import CreditRestoration from './pages/CreditRestoration';
import WealthEducation from './pages/WealthEducation';
import PlanDetail from './pages/PlanDetail';
import ManageYourCredit from './pages/ManageYourCredit';
import LifeHealthAnnuityInsurance from './pages/LifeHealthAnnuityInsurance';
import StartupBusinessGrowth from './pages/StartupBusinessGrowth';
import RealEstateMortgageConsulting from './pages/RealEstateMortgageConsulting';
import Financing from './pages/Financing';

function App() {

    return (
        <div className="App">
            <Router>
                <ScrolltoTop />
                <Routes>
                    <Route exact path="/" element={<Home />} />
                    <Route exact path="/about" element={<About />} />
                    <Route exact path="/contact" element={<Contact />} />
                    <Route exact path='/appointment' element={<Appointment />} />
                    <Route exact path='/pricing' element={<Pricing />} />
                    <Route exact path='/Credit-and-Financial-Solutions' element={<CreditandFinancialSolutions />} />
                    <Route exact path="/protection-plans/:title" element={<PlanDetail />} />
                    <Route exact path='/BusinessSolutions' element={<BusinessSolutions />} />
                    <Route exact path='/credit-restoration' element={<CreditRestoration />} />
                    <Route exact path='/wealth-education' element={<WealthEducation />} />
                    <Route exact path='/manage-your-credit' element={<ManageYourCredit />} />
                    <Route exact path='/life-health-annuity-insurance' element={<LifeHealthAnnuityInsurance />} />
                    <Route exact path='/startup-business-growth' element={<StartupBusinessGrowth />} />
                    <Route exact path='/real-estate-mortgage-consulting' element={<RealEstateMortgageConsulting />} />
                    <Route exact path='/Financing' element={<Financing />} />

                </Routes>
            </Router>
        </div>
    );

}
export default App;
